import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const CoinAnalysisSection = () => {
  const [selectedRange, setSelectedRange] = useState('');
  const [results, setResults] = useState('');

  const COIN_API_BASE_URL = 'https://wbl8e2qc9a.execute-api.ap-northeast-2.amazonaws.com/coin/genai-coin-analisys';

  const ranges = [
    { id: 'first_5', name: '거래대금 1위 ~ 5위' },
    { id: 'last_5', name: '거래대금 6위 ~ 10위' }
  ];

  const handleRangeClick = async (rankRange) => {
    setSelectedRange(rankRange);
    setResults('AI 분석을 수행 중입니다...');

    try {
      const response = await fetch(COIN_API_BASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rank_range: rankRange })
      });

      if (response.ok) {
        const data = await response.json();
        
        // 분석 결과를 문단별로 나누어 가독성 향상
        const formattedAnalysis = data.analysis
          .split('\n\n')  // 두 줄바꿈으로 문단 구분
          .filter(paragraph => !isBlankBlock(paragraph))
          .map(paragraph => `<div class="analysis-paragraph">${md(paragraph.trim())}</div>`)
          .join('');

        setResults(`
          <h3>📊 코인 분석 결과</h3>
          <div class="analysis-content">
            ${formattedAnalysis}
          </div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error('코인 분석 오류:', error);
      setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <section className="service-section">
      <h2>코인 분석 AI 서비스</h2>
      <p className="info-text">(업비트 기준 분석)</p>
      <div className="button-container">
        {ranges.map(range => (
          <button
            key={range.id}
            className={`category-btn ${selectedRange === range.id ? 'selected' : ''}`}
            onClick={() => handleRangeClick(range.id)}
          >
            {range.name}
          </button>
        ))}
      </div>
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default CoinAnalysisSection;